import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class GetContactDataGqlService {
  readonly document = gql`
    query GetContactData {
      contactContents {
        name
        socialTitle
        socialContent
        statusTitle
        statusContent
        transactTitle
        transactContent
        formTitle
      }
    }
  `;
}
